import { render, staticRenderFns } from "./NewAcctForExistingClient.vue?vue&type=template&id=c6e9c1ce&scoped=true&"
import script from "./NewAcctForExistingClient.vue?vue&type=script&lang=js&"
export * from "./NewAcctForExistingClient.vue?vue&type=script&lang=js&"
import style0 from "./NewAcctForExistingClient.vue?vue&type=style&index=0&id=c6e9c1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e9c1ce",
  null
  
)

export default component.exports